import { useEffect } from "react";
import { fetchDriverDetails } from "@/redux/driverDetailsSlice";
import { initializeFeatureFlag, storeActiveFleetId } from "@/utils/appInitializer";
import { useAppDispatch } from "@/redux/store";

interface AppInitializerProps {
  children: React.ReactNode;
}

const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initialize = async () => {
      // Check if user is signed in by looking for token
      const token = localStorage.getItem('auth_token');
      if (!token) {
        return; // Don't try to initialize if not signed in
      }

      try {
        const response = await dispatch(fetchDriverDetails()).unwrap();

        const userOrgId = response?.data?.user?.active_fleet_id || '';
        storeActiveFleetId(userOrgId);
        await initializeFeatureFlag(userOrgId);
      }
      catch (error) {
        console.error("Failed to initialize app:", error);
      }
    };

    initialize();
  }, []); // Empty dependency array means this runs once on mount

  return <>{children}</>;
};

export default AppInitializer; 